var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgDate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 10,
    width: 62,
    height: 72,
    rx: 7,
    transform: "rotate(90 72 10)",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 29,
    width: 8,
    height: 8,
    rx: 1,
    transform: "rotate(90 32 29)",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 29,
    width: 8,
    height: 8,
    rx: 1,
    transform: "rotate(90 48 29)",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 29,
    width: 8,
    height: 8,
    rx: 1,
    transform: "rotate(90 64 29)",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 43,
    width: 8,
    height: 8,
    rx: 1,
    transform: "rotate(90 16 43)",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 43,
    width: 8,
    height: 8,
    rx: 1,
    transform: "rotate(90 32 43)",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 43,
    width: 8,
    height: 8,
    rx: 1,
    transform: "rotate(90 48 43)",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 43,
    width: 8,
    height: 8,
    rx: 1,
    transform: "rotate(90 64 43)",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 57,
    width: 8,
    height: 8,
    rx: 1,
    transform: "rotate(90 16 57)",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 57,
    width: 8,
    height: 8,
    rx: 1,
    transform: "rotate(90 32 57)",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 6C68.866 6 72 9.13401 72 13L72 22L-6.99382e-07 22L-3.0598e-07 13C-1.36992e-07 9.134 3.13401 6 7 6L65 6Z",
    fill: "#3A8761"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 13,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 13,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 13,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 4,
    height: 15,
    rx: 2,
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 2C9 0.89543 9.89543 0 11 0C12.1046 0 13 0.895431 13 2V6H9V2Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    width: 4,
    height: 15,
    rx: 2,
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 2C34 0.89543 34.8954 0 36 0C37.1046 0 38 0.895431 38 2V6H34V2Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    width: 4,
    height: 15,
    rx: 2,
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 2C59 0.89543 59.8954 0 61 0C62.1046 0 63 0.895431 63 2V6H59V2Z",
    fill: "#B0D2EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDate);
export default __webpack_public_path__ + "static/media/imgDate.eb7e90963b9f7762f36d2b53b2ebdf35.svg";
export { ForwardRef as ReactComponent };